import { render, staticRenderFns } from "./SubmissionAddStep3.vue?vue&type=template&id=55799bd0"
import script from "./SubmissionAddStep3.vue?vue&type=script&lang=js"
export * from "./SubmissionAddStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports